import { useActiveTrial } from '@witmetrics/data-store';
import { formatTrialTimeRemaining, getSubscriptionUrl } from '@/utils/trials';
import Dialog from '@/components/Dialog';
import Button from '@/components/Button';
import IconButton from '@/components/IconButton';
import { CheckIcon, CloseIcon, SparklesIcon } from '@/icons';
import { PLAN_FEATURES } from './constants';
import { classes } from './utils';

export type TrialConversionDialogProps = {
  onClose: () => void;
};

export default function TrialConversionDialog({
  onClose,
}: TrialConversionDialogProps) {
  const activeTrial = useActiveTrial();

  const handleStartSubscription = () => {
    window.open(getSubscriptionUrl(), '_blank');
  };

  const renderFeature = (feature: string) => (
    <div key={feature} className={classes.feature}>
      <CheckIcon className={classes.checkIcon} size={15} strokeWidth={2.4} />
      {feature}
    </div>
  );

  const timeRemaining = formatTrialTimeRemaining(activeTrial?.timeRemaining);
  if (!timeRemaining) return null;

  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <div className={classes.header}>
        <span className={classes.iconTile}>
          <SparklesIcon size="1.25rem" />
        </span>
        <div className={classes.titles}>
          <h1 className={classes.title}>{timeRemaining} left in your trial</h1>
          <h2 className={classes.subtitle}>
            Start a subscription now to keep your cases, scan services and AI
            credits running without interruption.
          </h2>
        </div>
        <IconButton
          className={classes.closeButton}
          aria-label="close"
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.planCard}>
        <div className={classes.planRow}>
          <span className={classes.planName}>
            Unison<sup className={classes.aiMark}>[AI]</sup>
          </span>
          <span className={classes.planSpacer} />
          <span className={classes.planPrice}>€79</span>
          <span className={classes.planPriceUnit}>/ month</span>
        </div>
        <div className={classes.features}>
          {PLAN_FEATURES.map(renderFeature)}
        </div>
      </div>
      <Button className={classes.startButton} onClick={handleStartSubscription}>
        Continue with a subscription
      </Button>
      <Button
        className={classes.dismissButton}
        variant="ghost"
        onClick={onClose}>
        Continue trial
      </Button>
    </Dialog>
  );
}
